<template>
    <!-- 回单印鉴 弹框 -->
    <el-dialog class="receiptSign-SealDialog" :closeOnClickModal='false' width="60%" title="回单印鉴明细"
        :before-close="beforeClose" :visible="true">
        <div class="contentBox" v-if="sealData">
            <div class="contentBox-img">
                <div class="attachmentTitle" v-if="imgArr.length">
                    <span>上传人：{{ info.createUserCode }}</span>
                    <div style="padding-left: 70px;">{{ carouselIndex + 1 + ' / ' + imgArr.length }}</div>
                    <span>上传时间：{{ info.createTime }}</span>
                </div>
                <div v-else class="noImg">暂无图片</div>
                <div class="img-content">
                    <ul id='viewers' style="display: none;">
                        <li v-for='(item, index) in imgArr' :key='index'>
                            <img :src="item.path">
                        </li>
                    </ul>
                </div>
            </div>
            <div class="contentBox-remark">
                <h3>印鉴特殊要求</h3>
                <div>{{ sealData.remark }}</div>
                <div style="margin: 30px 0 0 20px;">
                    <div class="ai-text">
                        <span class="bold">签收要求：</span>
                        <span>{{ sealData.signRequest}}</span>
                    </div>
                    <div class="ai-text">
                        <span class="bold">回单类型：</span>
                        <span>{{ sealData.receiptTypeName}}</span>
                    </div>
                    <div class="ai-text">
                        <span class="bold">盖章公司名：</span>
                        <span>{{ sealData.stampCompanyNames || '-' }}</span>
                    </div>
                    <div class="ai-text">
                        <span class="bold">章类型：</span>
                        <span>{{ sealData.stampCompanyTypes || '-' }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="noData">暂无印鉴信息</div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取 消</el-button>
        </div>
    </el-dialog>
</template>
<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import { queryByTaskNo } from '@/modules/transport/otp/api/performanceReceiptBackCheck';

export default {
    name: 'sealDialog',
    props: {
        sealShow: {
            type: Boolean,
            default () {
                return false;
            }
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            info: {},
            sealData: null,
            carouselIndex: 0,
            imgArr: [],
            viewer: { destroy: () => { } },
            dialogLoading: { close: () => { } }
        };
    },
    methods: {
        loading (status = true) {
            this.dialogLoading.close();
            if (status) {
                this.dialogLoading = this.$loading({
                    target: '.receiptSign-SealDialog > div',
                    background: 'rgba(255, 255, 255, .7)'
                });
            } else {
                this.dialogLoading.close();
            }
        },
        beforeClose () {
            this.$emit('update:sealShow', false);
        },
        updateInfo () {
            this.info = this.imgArr[this.carouselIndex];
        },
        initViewer () {
            const barOptions = { show: true, size: 'small' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: true,
                button: true,
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    prev: {
                        show: true,
                        size: 'small',
                        click: () => {
                            if (this.carouselIndex === 0) {
                                this.carouselIndex = this.imgArr.length - 1;
                            } else {
                                this.carouselIndex -= 1;
                            }
                            this.updateInfo();
                            this.viewer.prev(true);
                        }
                    },
                    reset: barOptions,
                    next: {
                        show: true,
                        size: 'small',
                        click: () => {
                            if (this.carouselIndex === this.imgArr.length - 1) {
                                this.carouselIndex = 0;
                            } else {
                                this.carouselIndex += 1;
                            }
                            this.updateInfo();
                            this.viewer.next(true);
                        }
                    },
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
        },
        getSealInfo () {
            this.loading();
            queryByTaskNo(this.rowData.taskNo).then(res => {
                if (res && +res.code === 0 && res.data) {
                    this.sealData = res.data;
                    this.sealData.receiptTypeName = this.dictData.RECEIPT_TYPE[this.sealData.receiptType + ''] || '--';
                    (this.sealData.files || []).forEach(item => {
                        this.imgArr.unshift(item);
                    });
                    if (this.imgArr.length) {
                        this.info = this.imgArr[0];
                    }
                    this.$nextTick(() => {
                        this.initViewer();
                    });
                }
            }).finally(() => {
                this.loading(false);
            });
        }
    },
    mounted () {
        this.getSealInfo();
    },
    beforeDestroy () {
        this.viewer.destroy();
    }
};
</script>
<style lang="less">
.receiptSign-SealDialog {
    .contentBox {
        display: flex;
    }

    .contentBox-img {
        height: 300px;
        width: 60%;

        .attachmentTitle {
            margin: 10px 0;
            display: flex;
            justify-content: space-between;
        }

        .img-content {
            height: 100%;
        }
    }

    .contentBox-remark {
        .ai-text {
            width: 350px;
            font-size: 14px;
            margin-top: 10px;
            margin-bottom: 15px;
            text-align: left;
            overflow: hidden;
            .bold {
                font-weight: bold;
            }
        }
        flex: 1;

        >div {
            font-size: 13px;
        }
    }

    .noData,
    .noImg,
    .contentBox-remark {
        text-align: center;
    }

    .noImg {
        height: 300px;
        line-height: 300px;
    }
}</style>
